import React from 'react';
import ReactDOM from 'react-dom';

define([
  "globals",
  "jquery",
  "knockout",
  "header-view-model",
  'lozad',
  "modules/enews/enews",
  "sticky-kit",
  "scroll-to-top",
  "internal-user-sticky"],
function (globals, $, ko, HeaderViewModel, lozad) {

  $(".mt-font-menu").on("click", function() {
    $(".ab-header-menu").toggle("fast");
  });

  $(".ab-header").stick_in_parent();

  $(".ab-header-menu label a").on("click", function() {
    var isMobile = globals.ssm.getState("mobile").active;
    var isTabletOnly = globals.ssm.getState("tablet-only").active;
    var $checkbox = $(this).parent().prev();
    if (isMobile || isTabletOnly) {
      event.preventDefault();
      $checkbox.prop("checked", !$checkbox.prop("checked"));
    }
  });
  if ($(".bdc-header").length > 0) {
    var headerViewModel = new HeaderViewModel();
    ko.applyBindings(headerViewModel, $(".bdc-header").get(0));
  }

  $(".ab-menu-search, .ab-header-mobile-menu .mt-font-magnifier").on("click", function() {
    $(".ab-inlsrch").show();
    $(".ab-typeahead-input").focus();
  });
  $(".gcc-inlsrch-close").on("click", function() {
    $(".ab-inlsrch").hide();
  });

  $(".ab-header-menu li").on("click", function() {
    if ($(this).find("input[type=checkbox]").first().is(":checked")) {
      $(this).addClass("active");
    } else {
      $(this).removeClass("active");
    }
  });

  lozad(document.querySelector('#ab-footer'), {
    rootMargin: '200px 0px',
    loaded: () => {
      import(/* webpackChunkName: 'footer_ab' */ '../../../../../javascript/ab/footer').then((module) => {
        const getFooterData = module.default;
        getFooterData();
      });
      import(/* webpackChunkName: "enews" */ '../../../../../javascript/_shared/components/Enews').then((module) => {
        const Enews = module.default;
        ReactDOM.render(<Enews mode="dark" />, document.getElementById('gcc-enews'));
      });
    },
  }).observe();

  import(/* webpackChunkName: "paypal" */ '../../../../../javascript/_shared/components/paypalModal').then((module) => {
    const showPayPalCalculator = module.default;
    showPayPalCalculator();
  });

  import(/* webpackChunkName: "modals" */ '../../../../../javascript/_shared/modals').then((module) => {
    const Modals = module.default;
    ReactDOM.render(<Modals />, document.getElementById('ab-modals'));
  });

});
